function initSwipers() {
  var customerStories = new Swiper("#customers-stories .swiper-container", {
    //,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
      },
      480: {
        slidesPerView: 2,
      },
      800: {
        slidesPerView: 4,
      },
      1400: {
        slidesPerView: 4,
      },
    },
    //centeredSlides: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: {
      enabled: true,
      invert: true,
      forceToAxis: true,
    },
    scrollbar: {
      draggable: true,
    },
    slidesPerView: 5,
    spaceBetween: 20,
    navigation: {
      nextEl: ".slick-next",
      prevEl: ".slick-prev",
    },
  });
}

function calculateAge(dob) {
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);

  return Math.abs(age_dt.getUTCFullYear() - 1970);
}

// function convertFtToCm(ft, inch){
//   var feetCM = parseFloat(ft) * 30.48;
//   var inchCM = parseFloat(inch) * 2.54;

//   var cm = feetCM + inchCM;

//   return cm;
// }

// function convertLbToKg(lbs){
//   var lbsKg = parseFloat(lbs) / 2.20462;

//   return lbsKg;
// }

function getBMR(kg, cm, age, gender, exeFq) {
  console.log(
    "KG=" +
      kg +
      "-cm=" +
      cm +
      "-age=" +
      age +
      "-gender=" +
      gender +
      "-exeFQ=" +
      exeFq
  );
  var bmr = 0,
    amr = 0;

  if (gender == "women") {
    bmr = 10 * kg + 6.25 * cm - 5 * age - 161;
  } else {
    bmr = 10 * kg + 6.25 * cm - 5 * age + 5;
  }

  if (exeFq == "sedentary") {
    amr = 1.2;
  } else {
    if (exeFq == "lightly active") {
      amr = 1.375;
    } else {
      if (exeFq == "moderately active") {
        amr = 1.55;
      } else {
        if (exeFq == "active") {
          amr = 1.725;
        } else {
          amr = 1.9;
        }
      }
    }
  }
  console.log("BMR=" + bmr + "*" + amr);
  var resultBMR = bmr * amr;

  return parseInt(resultBMR);
}

function getBirthdayDate() {
  var date = new Date($("#birthdate").val());
}
// function showBMIResult(){

//   var date = new Date($('#birthdate').val());
//   var gender = $( "#gender" ).val();
//   var amr = $( "#amr" ).val();
//   var lbsTxt = $('#weight').val();
//   var ftTxt = $('#heightFt').val();
//   var inTxt = $('#heightIn').val();

//   var day = date.getDate();
//   var month = date.getMonth() + 1;
//   var year = date.getFullYear();

//   var age = calculateAge(new Date(year,month,day));

//   var weight = convertLbToKg(lbsTxt);
//   var height = convertFtToCm(ftTxt,inTxt);

//   var bmiResult = getBMR(weight,height,age,gender,amr);
//   var bmiCategory = '', bmiCategory = bmiResult < 16 ? "Severe Thinness" : bmiResult < 17 ? "Moderate Thinness" : bmiResult < 18.5 ? "Mild Thinness" : bmiResult < 25 ? "Normal" : bmiResult < 30 ? "Overweight" : bmiResult < 35 ? "Obese Class I" : bmiResult < 40 ? "Obese Class II" : "Obese Class III";

//   document.querySelector('#bmi-result').innerHTML = 'BMR = <span id="bmi-number">' + bmiResult + '</span><br>';
//   document.querySelector('#bmi-category').innerHTML = bmiCategory;
// };

function convertFtToMts(ft, inch) {
  var feetCM = parseFloat(ft) * 30.48;
  var inchCM = parseFloat(inch) * 2.54;

  var cm = feetCM + inchCM;
  var mts = cm / 100;

  return mts;
}

function convertLbToKg(lbs) {
  var lbsKg = parseFloat(lbs) / 2.20462;

  return lbsKg;
}

function getBMI(kg, mts) {
  var bmi = kg / (mts * mts);

  return bmi.toFixed(2);
}

function showBMIResult() {
  var lbsTxt = document.querySelector("#weight").value;
  var ftTxt = document.querySelector("#heightFt").value;
  var inTxt = document.querySelector("#heightIn").value;

  var weight = convertLbToKg(lbsTxt);
  var height = convertFtToMts(ftTxt, inTxt);

  var bmiResult = getBMI(weight, height);

  var bmiCategory = "",
    bmiCategory =
      bmiResult < 16
        ? "Severe Thinness"
        : bmiResult < 17
        ? "Moderate Thinness"
        : bmiResult < 18.5
        ? "Mild Thinness"
        : bmiResult < 25
        ? "Normal"
        : bmiResult < 30
        ? "Overweight"
        : bmiResult < 35
        ? "Obese Class I"
        : bmiResult < 40
        ? "Obese Class II"
        : "Obese Class III";
  document.querySelector("#bmi-result").innerHTML =
    'BMI= <span id="bmi-number">' + bmiResult + "</span><br>";
  document.querySelector("#bmi-category").innerHTML = bmiCategory;
}

KlaviyoSubscribe.attachToForms("#blog_calculator", {
  hide_form_on_success: false,
  success: function ($form) {
    showBMIResult();
  },
});

$(document).ready(function () {
  initSwipers();
});
